// Browser notification + service worker registration helpers
let swReady = null;

export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  if (window.location.protocol !== "https:" && window.location.hostname !== "localhost") return;
  swReady = navigator.serviceWorker
    .register("/service-worker.js")
    .catch((e) => console.warn("SW register failed", e));
}

export async function requestNotificationPermission() {
  if (!("Notification" in window)) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  return Notification.requestPermission();
}

export async function notify({ title, body, url, tag }) {
  if (!("Notification" in window) || Notification.permission !== "granted") return false;
  try {
    const reg = await navigator.serviceWorker?.ready;
    if (reg && reg.active) {
      reg.active.postMessage({ type: "show-notification", title, body, url, tag });
      return true;
    }
    new Notification(title, { body, icon: "/icon-192.png" });
    return true;
  } catch (e) {
    console.warn("notify failed", e);
    return false;
  }
}

export function canInstallPwa() {
  return !!window.deferredInstallPrompt;
}

let installPromptHandlerAttached = false;
export function attachInstallPromptHandler(setCanInstall) {
  if (installPromptHandlerAttached) return;
  installPromptHandlerAttached = true;
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.deferredInstallPrompt = e;
    setCanInstall && setCanInstall(true);
  });
  window.addEventListener("appinstalled", () => {
    window.deferredInstallPrompt = null;
    setCanInstall && setCanInstall(false);
  });
}

export async function triggerInstallPrompt() {
  const e = window.deferredInstallPrompt;
  if (!e) return null;
  e.prompt();
  const choice = await e.userChoice;
  window.deferredInstallPrompt = null;
  return choice.outcome;
}
